import React from 'react'
import { styledSystemTheme } from 'src/styles/theme'
import { ThemeProvider } from 'styled-components'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const wrapWithProvider = ({ element }: any) => {
  return <ThemeProvider theme={styledSystemTheme}>{element}</ThemeProvider>
}
